export default __webpack_public_path__ + "src/assets/previous-page-button.6fa541ea8d880d8a41b6ae10986d6d9d.svg";